import React, { useEffect, useRef } from 'react';

const formatTimer = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const OTPModal = ({
  otp,
  timer,
  otpError,
  isSubmitting,
  otpInputRefs,
  onOtpChange,
  onOtpKeyDown,
  onOtpPaste,
  onSubmit,
  onResend,
  onClose,
  pushToDataLayer,
}) => {
  const hasTrackedOtpEntryRef = useRef(false);

  const handleCloseClick = () => {
    pushToDataLayer({
      event: 'Enquiry_Form',
      eventCategory: 'Enquiry form',
      eventAction: 'Close Icon',
      eventLabel: 'NA',
      FormType: 'ELV Form',
      section_name: 'Contact Details',
    });

    onClose();
  };

  const handleResendClick = () => {
    pushToDataLayer({
      event: 'Enquiry_Form',
      eventCategory: 'Enquiry form',
      eventAction: 'Resend OTP',
      eventLabel: 'NA',
      FormType: 'ELV Form',
      section_name: 'Contact Details',
    });

    onResend();
  };

  useEffect(() => {
    if (otpInputRefs?.current?.[0]) {
      otpInputRefs.current[0].focus();
    }
  }, []);

  useEffect(() => {
    if (otp.every((digit) => digit === '')) {
      hasTrackedOtpEntryRef.current = false;
    }
  }, [otp]);

  return (
    <div className="modal-overlay">
      <div className="otp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Verify Mobile Number</h3>
          <button className="modal-close" onClick={handleCloseClick} aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-content">
          <p className="otp-instruction">Enter OTP</p>

          <form className="otp-form" onSubmit={onSubmit}>
            <div className="otp-inputs">
              {otp.map((value, index) => (
                <input
                  key={index}
                  ref={(el) => (otpInputRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  value={value}
                  onChange={(e) => {
                    onOtpChange(index, e.target.value);

                    if (e.target.value && !hasTrackedOtpEntryRef.current) {
                      pushToDataLayer({
                        event: 'Enquiry_Form',
                        eventCategory: 'Enquiry form',
                        eventAction: 'Enter OTP',
                        eventLabel: 'NA',
                        FormType: 'ELV Form',
                        section_name: 'Contact Details',
                      });
                      hasTrackedOtpEntryRef.current = true;
                    }
                  }}
                  onKeyDown={(e) => onOtpKeyDown(index, e)}
                  onPaste={onOtpPaste}
                  className={`otp-input ${otpError ? 'error' : ''}`}
                  disabled={isSubmitting}
                  aria-label={`OTP digit ${index + 1}`}
                />
              ))}
            </div>

            {otpError && (
              <p className="otp-error" role="alert">
                {otpError}
              </p>
            )}

            <p className="resend-otp">
              {timer > 0 ? (
                <>
                  Resend OTP{' '}
                  <span className="timer">
                    in <span className="grnTxt">{formatTimer(timer)}</span>
                  </span>
                </>
              ) : (
                <button type="button" onClick={handleResendClick} className="resend-button">
                  Resend OTP
                </button>
              )}
            </p>

            <button
              type="submit"
              className={`otp-submit-button ${
                otp.every((digit) => digit !== '') && !isSubmitting ? 'enabled' : ''
              }`}
              disabled={otp.some((digit) => digit === '') || isSubmitting}
            >
              {isSubmitting ? 'Verifying...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OTPModal;
